module.exports = __webpack_public_path__ + "static/fonts/element-icons.535877f5.woff";